import React from 'react';
import DashboardComponent from '../Dashboard/DashboardComponent';
import Home from '../LandingPage/Home';
import './MainIndex.css';

function MainIndex() {
  return (
    <div className="main-index-container">
      <div className="home-wrapper"><Home /></div>
      <div className="dashboard-wrapper"><DashboardComponent /></div>
    </div>
  );
}

export default MainIndex;
